<finxone-web-frontend-org-registration-number
  [registrationNumber]="registrationNumber"
  (registrationNumberChange)="valueChanges($event)"
></finxone-web-frontend-org-registration-number>
